var creditsQuantitySelect = {
  selectors: {
    "select": ".js-credits-quantity-select",
    "input": ".js-credits-quantity-input",
    "credits_actual": ".js-credits-actual-credits",
    "credits_after": ".js-credits-after-credits",
    "price": ".js-credits-price-total",
  },

  init: function () {
    const self = this;

    if (jQuery(self.selectors.select).length == 0) {
      return;
    }

    self.bindEvents();
  },

  bindEvents: function () {
    const self = this;

    jQuery(self.selectors.select).children("a").on("click", function (event) {
      event.preventDefault();

      const credits = jQuery(this).data("credits");

      jQuery(self.selectors.input).val(credits).trigger("input");
      if (credits === "") jQuery(self.selectors.input).focus();

      self.setActiveItem(this);
    });

    jQuery(self.selectors.input).on("input", function () {
      //Calc
      self.reCalc(jQuery(this).val());
    });
  },

  setActiveItem: function (selector_active_item) {
    const self = this;

    jQuery(self.selectors.select).children("a").removeClass("active");
    jQuery(selector_active_item).addClass("active");
  },

  reCalc: function (credits) {
    const self = this;

    credits = parseInt(credits);
    if (isNaN(credits)) credits = 0;
    if (credits > 1000000) credits = 1000000;
    if (credits < 0) credits = 0;


    const credits_actual = jQuery(self.selectors.credits_actual).text();
    jQuery(self.selectors.credits_after).text(parseInt(credits_actual) + credits);

    jQuery(self.selectors.price).text((credits * sikmoVars.currency_rate).toFixed(2).toLocaleString());
  }
}

// Export
export { creditsQuantitySelect };